export default __webpack_public_path__ + "delete.3afa2df598e51593.svg";